import React from "react";
import { useMephistoReview } from "../../shims/mephisto-review-hook";
import { useParams, useSearchParams } from "react-router-dom";
import {
  Icon,
  Spinner,
  Tooltip,
  Position,
} from "@blueprintjs/core";
import ErrorPane from "../../components/ErrorPane";
import { Navbar } from "../../components/Navbar";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { VersionSelector } from "../../components/VersionSelector/VersionSelector";

import "./Detail.scss"
import useAtomWithUrlParam from "../../hooks/useAtomWithUrlParam";
import { versionAtom, versionAtomDefault } from "../../atoms";

const PARAM_FILTER = ['t'] // Params filtered out when returning to main menu

const filter_params = (searchParams) => {
  PARAM_FILTER.forEach((f) => {
    searchParams.has(f) && searchParams.delete(f)
  });
  return searchParams;
}

function DetailView({
  itemRenderer: ItemRenderer,
  wrapClass,
}) {
  const { id } = useParams();
  const [version] = useAtomWithUrlParam(versionAtom, versionAtomDefault);
  const [searchParams,] = useSearchParams();
  const {
    data: item,
    isLoading,
    error,
    versionConfig,
  } = useMephistoReview({ taskId: id });
  const [copyBtnTxt, setCopyBtnTxt] = React.useState("Copy ID");

  useDocumentTitle(`${version} - ` + id);

  const onClickCopyBtn = () => {
    navigator.clipboard.writeText(id);
    setCopyBtnTxt("Copied!");
  }

  const onMouseLeaveCopyBtn = () => {
    setCopyBtnTxt("Copy ID");
  }

  const titleComponent = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%', marginLeft: '5px' }}>
    <div className="bp3-navbar-divider"></div>
    <span className="detail-title">Viewing video: <span className="detail-title-id">{id}</span></span>
    <Tooltip content={copyBtnTxt} position={Position.BOTTOM} openOnTargetFocus={false}>
      <Icon icon='duplicate' className="detail-copyid-btn" onClick={onClickCopyBtn} onMouseLeave={onMouseLeaveCopyBtn} />
    </Tooltip>
    <div style={{ marginLeft: 'auto', marginRight: '10px' }}>
      <VersionSelector validVersions={(item?.data._versions) || []} />
    </div>
  </div>;

  return (
    <>
      <Navbar prevPage={`/?${filter_params(searchParams).toString()}`} logoUrl={versionConfig?.logo}>
        {titleComponent}
      </Navbar>

      <main className={'item-view'}>
        {isLoading ? (
          <div className="item-dynamic">
            <ErrorPane error={error} />
            <h1 className="item-view-message"><Spinner /> Loading...</h1>
          </div>
        ) : item ? (
          wrapClass ? (
            <div className={wrapClass}>
              <ErrorPane error={error} />
              <ItemRenderer item={item} />
            </div>
          ) : (
            <>
              <ErrorPane error={error} />
              <ItemRenderer item={item} />
            </>
          )
        ) : (
          <div className="item-dynamic">
            <div className="item-view-message item-view-no-data">
              <ErrorPane error={error} />
              <h1 className="item-view-message">Error loading data</h1>
            </div>
          </div>
        )}
      </main>
    </>
  );
}

export default DetailView;
